import { Button, Image, Modal, Space, Tabs } from "antd";
import React, { useState } from "react";

function Donate(props) {
	const { mask } = props;
	const [open, setOpen] = useState(false);
	const [check, setCheck] = useState("1");

	function closeModal() {
		setOpen(false);
	}

	function openModal() {
		setOpen(true);
	}

	const item = [];

	function showColor() {
		if (check === "1") {
			return "#02C160";
		} else if (check === "2") {
			return "#1678FF";
		}
	}

	function showMask() {
		return mask === 0 ? false : true;
	}

	return (
		<>
			{/* eslint-disable-next-line */}
			<a onClick={openModal} rel="noreferrer">
				关于系统
			</a>
		</>
	);
}

export default Donate;
